/**
 * @surfline/quiver-react v12.14.9 2020-10-22
 */

/* istanbul ignore next */
const checkConditionValue = condition => {
  if (!condition) return 'LOLA';
  if (condition === 'NONE') return 'LOLA';
  return condition;
};

export default checkConditionValue;
//# sourceMappingURL=checkConditionValue.js.map
